import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';
import DirectoryPage from '@/views/DirectoryPage.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'login',

        component: LoginPage,
    },
    {
        path: '/directory',
        name: 'directory',
        component: DirectoryPage,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
